module.exports = __webpack_public_path__ + "fonts/montserrat-v30-latin-300.a155b58.woff2";